import { createContext } from 'react'

export const InitDataContext = createContext(null)

export const InitActionsContext = createContext(null)
